module.exports = __webpack_public_path__ + "img/product-qrcode.937c2905.png";